import { render } from "./ComputerScienceView.vue?vue&type=template&id=6bec815c&scoped=true"
import script from "./ComputerScienceView.vue?vue&type=script&lang=js"
export * from "./ComputerScienceView.vue?vue&type=script&lang=js"

import "./ComputerScienceView.vue?vue&type=style&index=0&id=6bec815c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bec815c"]])

export default __exports__